function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMapPopupQualito({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 50 50",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "layer1",
    transform: "matrix(1, 0, 0, 1, -4.135209, -220.561218)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#000000",
      strokeWidth: 0.26458332
    },
    d: "",
    id: "path270"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#000000",
      strokeWidth: 0.26458332
    },
    d: "",
    id: "path268"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#000000",
      strokeWidth: 0.26458332
    },
    d: "",
    id: "path266"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#000000",
      strokeWidth: 0.26458332
    },
    d: "",
    id: "path264"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#000000",
      strokeWidth: 0.26458332
    },
    d: "",
    id: "path260"
  }), /*#__PURE__*/React.createElement("g", {
    id: "g25",
    transform: "translate(-77.428194,113.02319)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1.941967, 0, 0, 1.997398, 7.102864, -225.802689)",
    id: "g382",
    style: {}
  }, /*#__PURE__*/React.createElement("path", {
    id: "path388",
    d: "m 38.897474,191.65894 c -0.661018,-0.26672 -0.301316,-1.25759 1.078281,-2.97032 0.774956,-0.96208 2.739487,-3.50615 4.365625,-5.65348 l 2.956615,-3.90423 V 173.459 c 0,-6.90725 -0.255206,-6.49566 4.027621,-6.49566 4.107186,0 3.907177,-0.33408 3.920526,6.54843 l 0.01064,5.49011 3.978087,5.15937 c 2.187948,2.83766 4.167013,5.54061 4.397922,6.00657 0.847069,1.7093 1.150689,1.66879 -12.332304,1.64546 -6.639749,-0.0115 -12.221108,-0.0809 -12.403009,-0.15434 z m 22.158854,-1.83722 c 0,-0.0882 -0.367191,-0.62398 -0.815983,-1.19062 -0.766299,-0.96753 -0.902285,-1.03026 -2.233343,-1.03026 -0.779549,0 -1.490945,-0.11907 -1.580882,-0.26459 -0.09988,-0.16161 0.305932,-0.26458 1.042717,-0.26458 0.663432,0 1.206241,-0.0974 1.206241,-0.21649 0,-0.11906 -0.382667,-0.71437 -0.850371,-1.32291 -0.838758,-1.09132 -0.873082,-1.10643 -2.513541,-1.10643 -0.932392,0 -1.663171,-0.11626 -1.663171,-0.26459 0,-0.14552 0.595312,-0.26458 1.322916,-0.26458 0.727605,0 1.322917,-0.0698 1.322917,-0.15518 0,-0.0854 -0.37737,-0.68067 -0.838602,-1.32292 -0.826715,-1.15118 -0.86047,-1.16773 -2.38125,-1.16773 -0.852043,0 -1.542648,-0.11845 -1.542648,-0.26459 0,-0.14552 0.535781,-0.26458 1.190625,-0.26458 1.118117,0 1.525488,-0.29098 0.926042,-0.66146 -0.147679,-0.0913 -0.264584,-1.32566 -0.264584,-2.79374 v -2.63022 h -1.984375 -1.984374 v 2.43863 2.43862 l -3.972968,5.23429 -3.972967,5.2343 h 9.793801 c 5.38659,0 9.7938,-0.0722 9.7938,-0.16037 z M 53.383411,170.7998 v -1.98438 h -1.984375 -1.984374 v 1.98438 1.98437 h 1.984374 1.984375 z",
    style: {
      fill: "#FFFFFF",
      strokeWidth: 0.26458332
    }
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMapPopupQualito);
export default __webpack_public_path__ + "static/media/map_popup_qualito.8cb56312e3b8c30b03778453d4ef7911.svg";
export { ForwardRef as ReactComponent };